import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query predefinedUserScreenerSummary{
    predefinedUserScreenerSummary{
      id
      name
      filterJson
      totalResultCount,
      newCompaniesTotalHits
      isLimited
    }
  }
`);

export const useMyScreeners = makeGqlSuspenseQuery(QUERY);
